import { Fab } from '@mui/material';
import { Instagram as InstagramButton } from '@mui/icons-material';
import { styled } from '@mui/material/styles';
import { useMediaQuery } from 'react-responsive';

const FloatingButton = styled(Fab)<{ $isMobile: boolean; $isTablet: boolean }>(({ theme, $isMobile, $isTablet }) => ({
  position: 'fixed',
  bottom: $isMobile ? '110px' : '110px',
  right: $isMobile ? '20px' : '20px',
  zIndex: 1050,
  width: $isMobile ? '50px' : '60px',
  height: $isMobile ? '50px' : '60px',
  backgroundColor: '#DD2A7B !important', // !important para sobrescribir estilos de MUI
  color: 'white !important',
  boxShadow: '0 4px 12px rgba(0, 0, 0, 0.3)',
  '&:hover': {
    transform: 'scale(1.1)',
    backgroundColor: '#a61d5a !important', // Verde más oscuro para hover
    color: 'white !important'
  },
  '&:focus': {
    backgroundColor: '#DD2A7B !important',
    color: 'white !important'
  },
  '&:active': {
    backgroundColor: '#a61d5a !important',
    color: 'white !important'
  },
  '@media (max-width: 768px)': {
    bottom: '110px',
    right: '15px',
    width: '50px',
    height: '50px'
  },
  '@media (max-width: 480px)': {
    bottom: '110px',
    right: '15px',
    width: '50px',
    height: '50px'
  }
}));

export const FloatingInstagramButton = () => {
  const isMobile = useMediaQuery({ query: '(max-width: 768px)' });
  const isTablet = useMediaQuery({ query: '(min-width: 769px) and (max-width: 1024px)' });

  const handleClick = () => {
    window.location.href = 'https://www.instagram.com/comunidadcuore?igsh=cGR4aHNubGVsdTlv&utm_source=qr';
  };

  return (
    <FloatingButton
      sx={{ color: '#a61d5a', fontSize: '25px' }}
      onClick={handleClick}
      $isMobile={isMobile}
      $isTablet={isTablet}
    >
      <InstagramButton sx={{ fontSize: isMobile ? '30px' : '40px', color: 'white' }} />
    </FloatingButton>
  );
};
